import { SVGProps, Ref, forwardRef } from 'react';

export const Diagram80Size24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.8a8.2 8.2 0 1 1-7.101 4.1L3.339 7A10 10 0 1 0 12 2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
Diagram80Size24Glyph.displayName = 'Diagram80Size24Glyph';
